export enum CastRole {
  GuestStar = 'GUEST_STAR',
  Star = 'STAR',
}

export enum CrewJob {
  Creator = 'CREATOR',
  Director = 'DIRECTOR',
  ExecutiveProducer = 'EXECUTIVE_PRODUCER',
  Novel = 'NOVEL',
  Producer = 'PRODUCER',
  Screenplay = 'SCREENPLAY',
  Writer = 'WRITER',
}

// Lookup required because themoviedb returns human-readable strings
// for the values, rather than pascal case strings.
export enum CastRoleLookup {
  GuestStar = 'Guest Star',
  Star = 'Star',
}

// Lookup required because themoviedb returns human-readable strings
// for the values, rather than pascal case strings.
export enum CrewJobLookup {
  Creator = 'Creator',
  Director = 'Director',
  ExecutiveProducer = 'Executive Producer',
  Novel = 'Novel',
  Producer = 'Producer',
  Screenplay = 'Screenplay',
  Writer = 'Writer',
}
